module.exports = __webpack_public_path__ + "img/card-checklist.070cf1c8.svg";